import { styled } from "styled-components";
import Button from "../../components/Button/Button";
import {
  ArrowRightWhite,
  StarsOverlay,
  VirtualCards,
  VirtualCardsMobile,
} from "../../../public/assets";
import { colors } from "../../theme/color";

export const VirtualCardBanner = () => {
  return (
    <BannerWrapper>
      <BannerLeft>
        <HeaderText>Get your virtual & physical debit card</HeaderText>
        <Paragraph>
          Finish your account set up to have access to all our products
        </Paragraph>
        <Button
          id={""}
          type="button"
          onClick={() => {}}
          padding={"10px 30px"}
          border="10px"
          green
        >
          <ButtonChildren>
            <span>Get Started</span>
            <img src="/assets/icons/arrowRightWhite.svg" alt="Arrow" />
          </ButtonChildren>
        </Button>
      </BannerLeft>
      <VirtualCardImg>
        <VirtualCardsImg
          src="/assets/svg/virtualCards.svg"
          alt="Fast settlement"
        />
        <VirtualCardsMobileImg
          src="/assets/svg/virtualCardsMobile.svg"
          alt="Fast settlement"
        />
      </VirtualCardImg>
      <Image src="/assets/svg/starsOverlay.svg" alt="stars overlay" />
    </BannerWrapper>
  );
};

export const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #5e5e5e;
  line-height: 24px;
`;
export const HeaderText = styled.h3`
  color: ${colors.NAVYBLUE};
  font-size: 26px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.5px;
  @media screen and (max-width: 767px) {
    font-weight: 700;
  }
`;
export const BannerWrapper = styled.div`
  background-color: ${colors.White};
  width: 78vw;
  border-radius: 10px;
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    height: auto;
    width: 100%;
    flex-direction: column;
  }
  @media screen and (min-width: 768px) and (max-width: 768px) {
    width: 100%;
  }
`;
export const BannerLeft = styled.div`
  padding: 2rem 1rem 2rem 1rem;
`;

export const Image = styled.img`
  position: absolute;
  right: 12%;
  top: 8%;
  height: 250px;
  width: 250px;
  @media screen and (max-width: 767px) {
    height: 160px;
    width: 160px;
    right: 30%;
    top: 65%;
  }
`;

export const ButtonChildren = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const VirtualCardImg = styled.div`
  padding-top: 4rem;
`;
export const VirtualCardsImg = styled.img`
  display: flex;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;
export const VirtualCardsMobileImg = styled.img`
  display: none;
  @media screen and (max-width: 767px) {
    display: flex;
  }
`;
